import React from 'react';
import './OrderListHeader.css';

function OrderListHeader() {
  return (
    <div className="order-list-header-row">
      {/* 1. 카드의 status-sidebar와 동일한 돔 구조 */}
      <div className="header-sidebar-box">상태</div>
      
      {/* 2. 카드의 order-content와 동일한 돔 구조 */}
      <div className="header-content-box">
        {/* 3. 카드의 order-main-info와 동일한 그리드 구조 */}
        <div className="header-grid-layout">
          <div className="header-cell">작업명</div>
          <div className="header-cell">소재종류</div>
          <div className="header-cell">소재모양</div>
          <div className="header-cell">소재크기</div>
          <div className="header-cell">절단길이</div>
          <div className="header-cell">작업수량</div>
          <div className="header-cell">지시시간</div>
          <div className="header-cell">완료시간</div>
          <div className="header-cell">작업지시</div>
        </div>
      </div>
    </div>
  );
}

export default OrderListHeader;